<template>
  <div>
    <div class="desc-list">
      <!-- <div class="desc-item">
        <div class="key">所属站点：</div>
        <div class="value">{{ refundDetail.orderNo }}</div>
      </div> -->
      <div class="desc-item">
        <div class="key">退款单号：</div>
        <div class="value">{{ refundDetail.outRefundNo }}</div>
      </div>
      <div class="desc-item">
        <div class="key">提交时间：</div>
        <div class="value">{{ refundDetail.gmtCreate }}</div>
      </div>
      <div class="desc-item">
        <div class="key">退款状态：</div>
        <div class="value">{{ refundDetail.statusText }}</div>
      </div>
      <div class="desc-item">
        <div class="key">退款方式：</div>
        <div class="value">{{ refundDetail.remark }}</div>
      </div>
      <div class="desc-item">
        <div class="key">申请退款总价：</div>
        <div class="value">{{ refundDetail.applyRefundFee | price }}</div>
      </div>
      <div class="desc-item">
        <div class="key">退款原因：</div>
        <div class="value" v-if="refundDetail.remark == '自助退款'">
          {{ refundDetail.refundDesc }}
        </div>
        <div class="value" v-else>无</div>
      </div>
      <div class="desc-item">
        <div class="key">申请退款课时服务费：</div>
        <div class="value">{{ refundDetail.applyRefundCourseFee | price }}</div>
      </div>
      <div class="desc-item">
        <div class="key">申请退款教材费：</div>
        <div class="value">
          {{ refundDetail.applyRefundTextbookFee | price }}
        </div>
      </div>
      <div class="desc-item">
        <div class="key">实际退款总价：</div>
        <div class="value">{{ refundDetail.refundFee | price }}</div>
      </div>
      <div class="desc-item">
        <div class="key">课程服务费：</div>
        <div class="value">{{ refundDetail.coursePrice | price }}</div>
      </div>
      <div class="desc-item">
        <div class="key">教材费用：</div>
        <div class="value">{{ refundDetail.textbookPrice | price }}</div>
      </div>
    </div>

    <div class="desc-list">
      <div class="desc-item1">
        <div class="key">订单号：</div>
        <div class="value">
          {{ refundDetail.orderNo }}
          <span class="cross" v-if="refundDetail.isCrossSchool == 1">
            <img src="/crossSchool.png" style="width: 16px" alt="" />
            <em>跨校订单</em>
          </span>
        </div>
      </div>
      <div class="desc-item">
        <div class="key">支付单号：</div>
        <div class="value">{{ refundDetail.transId }}</div>
      </div>
      <div class="desc-item">
        <div class="key">提交时间：</div>
        <div class="value">{{ refundDetail.orderGmtCreate }}</div>
      </div>
      <div class="desc-item">
        <div class="key">订单总价：</div>
        <div class="value">{{ refundDetail.totalPrice | price }}</div>
      </div>
      <div class="desc-item">
        <div class="key">课程服务费：</div>
        <div class="value">{{ refundDetail.coursePrice | price }}</div>
      </div>
      <div class="desc-item">
        <div class="key">教材费用：</div>
        <div class="value">{{ refundDetail.textbookPrice | price }}</div>
      </div>
      <div class="desc-item">
        <div class="key">班级名称：</div>
        <div class="value">
          {{ refundDetail.className ? refundDetail.className : '无' }}
        </div>
      </div>
      <div class="desc-item">
        <div class="key">班级学校：</div>
        <div class="value">{{ refundDetail.classSchool }}</div>
      </div>
      <div class="desc-item">
        <div class="key">订单类型：</div>
        <div class="value">{{ refundDetail.orderTypeText }}</div>
      </div>
      <div class="desc-item">
        <div class="key">课程名称：</div>
        <div class="value">
          {{ refundDetail.className ? refundDetail.className : '无' }}
        </div>
      </div>
      <div class="desc-item">
        <div class="key">学员学校：</div>
        <div class="value">{{ refundDetail.studentSchool }}</div>
      </div>
      <div class="desc-item">
        <div class="key">学生：</div>
        <div class="value">{{ refundDetail.studentName }}</div>
      </div>
      <div class="desc-item">
        <div class="key">原始班级：</div>
        <div class="value">{{ refundDetail.originalClassName }}</div>
      </div>
      <div class="desc-item">
        <div class="key">来源：</div>
        <div class="value">
          {{
            refundDetail.offeringTypeText ? refundDetail.offeringTypeText : '无'
          }}
        </div>
      </div>

      <div class="desc-item">
        <div class="key">提供方：</div>
        <div class="value">
          {{ refundDetail.providerName ? refundDetail.providerName : '无' }}
        </div>
      </div>
      <div class="desc-item" v-if="refundDetail.offeringType == 2">
        <div class="key">课程方种类：</div>
        <div class="value">{{ refundDetail.institutionTypeName }}</div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'refundInfo',
  props: ['refundDetail'],
}
</script>
<style lang="scss" scoped>
.desc-list {
  margin-bottom: 30px;
}

.desc-item {
  width: calc(50% - 10px);
  margin-right: 10px;
  display: inline-block;
  padding: 4px 0px;
  font-size: 14px;
  > .key {
    width: 140px;
    text-align: right;
    display: inline-block;
    vertical-align: top;
    color: rgba(0, 0, 0, 0.85);
  }
  > .value {
    display: inline-block;
    width: calc(100% - 140px);
    vertical-align: top;
    color: rgba(0, 0, 0, 0.65);
  }
}
.desc-item1 {
  width: calc(100% - 10px);
  margin-right: 10px;
  display: inline-block;
  padding: 4px 0px;
  font-size: 14px;
  > .key {
    width: 140px;
    text-align: right;
    display: inline-block;
    vertical-align: top;
    color: rgba(0, 0, 0, 0.85);
  }
  > .value {
    display: inline-block;
    width: calc(100% - 140px);
    vertical-align: top;
    color: rgba(0, 0, 0, 0.65);
  }
}
.cross {
  margin-left: 5px;
  color: #d71616 !important;
  // img {
  //   margin-bottom: 2px;
  // }
  em {
    border: 1.5px solid #d71616;
    border-radius: 4px;
    margin-left: 2px;
    font-style: normal;
  }
}
</style>
